import $ from "jquery";
import "slick-carousel";
import Bowser from "bowser";

const CarouselEpisodes = () => {
  // Hide previous arrow by default when opening page
  $(".episode__wrapper").on("init", function () {
    $(".slick-prev.slick-arrow").hide();
  });

  // Begin Slick config for episodes carousel
  $(".episode__wrapper").slick({
    slidesToShow: 3,
    slidesToScroll: 2,
    mobileFirst: true,
    variableWidth: true,
    adaptiveHeight: false,
    dots: false,
    arrows: true,
    lazyLoad: "progressive",
    centerMode: false,
    infinite: false,
    touchThreshold: 10,
    UseCSS: false,
    useTransform: false,
    speed: "10",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          centerMode: false,
          autoplay: false,
          touchThreshold: 10,
          useCSS: false,
          useTransform: false,
          speed: "10",
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          centerMode: false,
          autoplay: false,
          touchThreshold: 10,
          arrows: true,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          centerMode: false,
          autoplay: false,
          touchThreshold: 10,
          arrows: true,
        },
      },
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 4,
          centerMode: false,
          centerPadding: "140px",
          autoplay: false,
          variableWidth: true,
          draggable: true,
          speed: "10",
          touchThreshold: 20,
          cssEase: "ease",
          arrows: true,
        },
      },
      {
        breakpoint: 1919,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 4,
          centerMode: false,
          autoplay: false,
          draggable: true,
          touchThreshold: 20,
          cssEase: "ease",
          arrows: true,
        },
      },
      {
        breakpoint: 2559,
        settings: {
          slidesToShow: 11,
          slidesToScroll: 6,
          centerMode: false,
          autoplay: false,
          draggable: true,
          touchThreshold: 20,
          cssEase: "ease",
          arrows: true,
        },
      },
    ],
  });

  /*
   */
  const browser = Bowser.getParser(window.navigator.userAgent);

  $(".episode__wrapper").on("afterChange", function (
    event,
    slick,
    currentSlide
  ) {
    window.is__carousel__scrolling = false;

    // Hide previous arrow for carousel when not at the starting point
    if (browser.getPlatformType() === "desktop" && currentSlide >= 1) {
      $(".slick-prev.slick-arrow").show();
    } else {
      $(".slick-prev.slick-arrow").hide();
    }
  });

  $(".episode__wrapper").on("beforeChange", function () {
    window.is__carousel__scrolling = true;
  });
};

export default CarouselEpisodes;
